import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Feedback} from '../../../common/services';

@Component({
  selector: 'app-feedback-modale',
  templateUrl: './feedback-modale.component.html',
  styleUrls: ['./feedback-modale.component.scss']
})
export class FeedbackModaleComponent implements OnInit {

  constructor(@Inject(LOCALE_ID) private locale: string,
              @Inject(MAT_DIALOG_DATA) public data: Feedback,
              public dialogRef: MatDialogRef<FeedbackModaleComponent>) { }

  ngOnInit() {
  }

}
